import React from 'react';

import WinXP from 'WinXP';
import { useGA } from 'hooks';
import BootSplash from './BootSplash';

const App = () => {
  useGA('UA-135148027-3', 'winXP');
  return (
    <>
      <BootSplash />
      <WinXP />
    </>
  );
};

export default App;